import { getWeekdays } from '@hakimo-ui/hakimo/util';
import clsx from 'clsx';

interface Props {
  selectedDays: boolean[];
  updateSelectedDays: (enabledDays: boolean[]) => void;
  disableSelectedDays?: boolean;
}

export function WeekdayActions(props: Props) {
  const { selectedDays, updateSelectedDays, disableSelectedDays } = props;

  const onClick = (i: number) => () => {
    const updated = [...selectedDays];
    updated[i] = !updated[i];
    updateSelectedDays(updated);
  };

  return (
    <div className="dark:text-ondark-text-2 bg-on flex items-center justify-center gap-2">
      {getWeekdays().map((day, i) => (
        <button
          className={clsx(
            'w-6',
            'dark:text-ondark-text-1 rounded-full border-transparent p-1 text-sm font-medium disabled:opacity-75',
            selectedDays[i]
              ? 'text-ondark-text-1 bg-primary-500 enabled:hover:bg-primary-700 dark:enabled:hover:bg-primary-600'
              : 'bg-ondark-text-1 dark:bg-ondark-bg-3 dark:enabled:hover:bg-ondark-text-3 enabled:hover:bg-ondark-text-2 text-onlight-text-2'
          )}
          disabled={disableSelectedDays && selectedDays[i]}
          key={day.name}
          onClick={onClick(i)}
          title={day.name}
        >
          {day.symbol}
        </button>
      ))}
    </div>
  );
}
